import { request } from '../../../utils/api';
import { FETCH_PERMISSIONS } from '../../../constants/endpoints';
import { showToast } from '../toasts';
import actionTypes from '../../../constants/actions';

const fetchPermissionsStarted = () => ({
  type: actionTypes.FETCH_PERMISSIONS,
  status: 'started',
});

const fetchPermissionsError = () => ({
  type: actionTypes.FETCH_PERMISSIONS,
  status: 'started',
});

const fetchPermissionsSuccess = (data) => (dispatch) =>
  dispatch({
    type: actionTypes.FETCH_PERMISSIONS,
    status: 'success',
    data: data,
  });

const transformData = (arr) => {
  return arr.reduce((acc, curr) => {
    if (!curr.module) {
      curr.module = 'material';
    }
    if (!acc[curr.module]) {
      acc[curr.module] = [];
    }
    acc[curr.module].push({
      id: curr._id,
      key: curr.key,
      label: curr.label,
      // Pass through description so it can be shown in permission tooltips
      description: curr.description,
    });
    return acc;
  }, {});
};

const fetchPermissions = () => async (dispatch) => {
  try {
    dispatch(fetchPermissionsStarted());
    const { permissions, isAdmin } = await request({
      route: FETCH_PERMISSIONS(),
      data: {},
      method: 'get',
      dispatch,
    });

    // THIS IS A DUMMY JSON FOR TESTING PURPOSE
    // const { permissions, isAdmin } = {
    //   permissions: [
    //     {
    //       _id: '68ecfcb905fa4686ebabfec0',
    //       key: 'material:create',
    //       label: 'Create Material',
    //       module: 'material',
    //     },
    //     {
    //       _id: '68ecfcba05fa4686ebabfeed',
    //       key: 'material:edit',
    //       label: 'Edit Material',
    //       module: 'material',
    //     },
    //     {
    //       _id: '68f0ba9ca760145c71ea96a2',
    //       key: 'material:view',
    //       label: 'View Material',
    //       module: 'material',
    //     },
    //     {
    //       _id: '68f0ba9da760145c71ea96d2',
    //       key: 'material:delete',
    //       label: 'Delete Material',
    //       module: 'material',
    //     },
    //     {
    //       _id: '68ecfcb905fa4686ebabfec1',
    //       key: 'common_room:post',
    //       label: 'Post in Common Room',
    //       module: 'common room',
    //     },
    //     {
    //       _id: '68ecfcba05fa4686ebabfeedc',
    //       key: 'common_room:pin',
    //       label: 'Pin post in Common Room',
    //       module: 'common room',
    //     },
    //     {
    //       _id: '68f0ba9ca760145c71ea96a2a',
    //       key: 'common_room:edit',
    //       label: 'Edit post in Common Room',
    //       module: 'common room',
    //     },
    //     {
    //       _id: '68ecfcba05fa4686ebabfeed2s',
    //       key: 'users:create',
    //       label: 'Add users in space',
    //       module: 'users',
    //     },
    //     {
    //       _id: '68f0ba9ca760145c71ea96a21',
    //       key: 'users:delete',
    //       label: 'Delete users in space',
    //       module: 'users',
    //     },
    //     {
    //       _id: '68ecfcba05fa4686ebabfeed2',
    //       key: 'announcement:post',
    //       label: 'Post in Announcement',
    //       module: 'Announcement',
    //     },
    //     {
    //       _id: '68f0ba9ca760145c71ea96a24',
    //       key: 'announcement:delete',
    //       label: 'Delete post in Announcement',
    //       module: 'Announcement',
    //     },
    //   ],
    //   isAdmin: true,
    // };

    if (isAdmin) {
      const transformedData = transformData(permissions);
      dispatch(fetchPermissionsSuccess(transformedData));
      return transformedData;
    }
    return null;
  } catch (e) {
    dispatch(
      showToast({
        message: e.response.data.message || e.response.data || e.message,
      }),
    );
    dispatch(fetchPermissionsError());
    throw Error(e.message);
  }
};

export default fetchPermissions;
